import apiService from "../../api/api.service";
import rules from "../../utils/rules";
import ImageInput from "@/views/ImageInput";
import pageheader from "../pageheader";
import utils from "../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "profile",
  components: {
    ImageInput,
    pageheader,
  },
  data() {
    return {
      valid: true,
      loading: false,
      result: [],
      isEditing: false,
      rules: rules,
      avatar: {
        imageURL: null,
      },
      saved: false,
      isUpload: false,
      isAvatar: false,
      isProfile: false,
      roleChange: "",
      phoneCountryCode: "1",
      cellCountryCode: "1",
      phoneCountryName: "us",
      cellCountryName: "us",
      input: {},
      id: null,
    };
  },
  watch: {
    avatar: {
      handler: function (val) {
        if (val.isUpload) {
          this.isAvatar = true;
        }
        this.saved = false;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("profile", this.roles);
    this.id = this.$store.getters.id;
    this.getProfileById();
  },
  methods: {
    onSelectPhone({ iso2, dialCode }) {
      this.phoneCountryCode = dialCode;
      this.phoneCountryName = iso2;
    },
    onSelectOffice({ iso2, dialCode }) {
      this.cellCountryCode = dialCode;
      this.cellCountryName = iso2;
    },
    async getProfileById() {
      this.isProfile = true;
      try {
        this.result = await apiService.getProfile(this.id);
        this.result = this.result.data ? this.result.data : this.result;
        if (this.result.role == "Customer") {
          this.roleChange = "External Customer";
        } else if (this.result.role == "Support Admin") {
          this.roleChange = "ProServ Portal Manager";
        } else if (this.result.role == "Support Manager") {
          this.roleChange = "ProServ Portal Support Manager";
        } else if (this.result.role == "Vendor") {
          this.roleChange = "External Vendor/OEM";
        } else {
          this.roleChange = this.result.role;
        }
        if (this.result.profilePicture) {
          this.avatar.imageURL = this.result.profilePicture;
        }
        if (this.result.phoneCountryCode) {
          this.phoneCountryCode = this.result.phoneCountryCode;
          this.phoneCountryName = this.result.phoneCountryName;
        }
        if (this.result.cellCountryCode) {
          this.cellCountryCode = this.result.cellCountryCode;
          this.cellCountryName = this.result.cellCountryName;
        }
        this.isProfile = false;
      } catch (err) {
        this.isProfile = false;
        this.$toast.error("Unable to load the report requests" + err);
      }
    },
    cancelUpdate(isedit) {
      this.isEditing = !isedit;
    },
    async uploadImage() {
      this.isUpload = true;
      try {
        let payload = {
          detail: this.avatar.imageString,
        };
        let response = await apiService.updateProfileImage(this.id, payload);
        if (response.isSuccess) {
          this.$toast.success(response.systemMessage);
          this.$store.dispatch("setProfilePicture", this.avatar.imageString);
        }
        this.isUpload = false;
      } catch (err) {
        this.isUpload = false;
        this.$toast.error("Unable to upload profile image" + err);
      }
      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.isAvatar = false;
      this.saved = true;
    },
    cancelUpload() {
      this.avatar.imageURL = this.result.profilePicture;
      setTimeout(() => this.savedAvatar(), 5);
    },
    async profileUpdate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let userPhoneNumber = this.result.phoneNumber.replace(/\D+/g, "");
        let userOfficePhone = this.result.officePhone.replace(/\D+/g, "");
        let payload = {
          firstName: this.result.firstName,
          lastName: this.result.lastName,
          phoneCountryCode: this.phoneCountryCode,
          phoneNumber: userPhoneNumber,
          phoneCountryName: this.phoneCountryName,
          cellCountryCode: this.cellCountryCode,
          cellCountryName: this.cellCountryName,
          officePhone: userOfficePhone,
          userName: this.result.email,
        };
        try {
          let apiResponse = await apiService.updateProfile(this.id, payload);
          if (apiResponse) {
            this.loading = false;
            this.$toast.success(apiResponse.systemMessage);
            this.cancelUpdate(true);
          }
        } catch (err) {
          this.loading = false;
          this.$toast.error("Oops!!! something went wrong" + err);
          this.getProfileById();
        }
      }
    },
  },
};
